import { v4 as uuid } from 'uuid';
import { BindersApi, IssuesApi, UsersApi } from '../../Utils/apis';
import { iBinderFetch, noTenantFetch } from '../../Utils/iBinderFetch';
import { ImpersonateTenant } from '../../Utils/impersonateTenant';
import {
  getStandardIssueTemplate,
  getStandardTabTemplate,
  getStandardWorkflowTemplate
} from './issueTemplate';

const id = uuid();
const githubUrl = `https://github.com/iBinder/admins-ui/tree/main/${__filename}`;

// *****************************************************************************
// START - The part between START and END is the part that is added to the file.
// *****************************************************************************
const name = 'Create a new custom process and a tab template';
const description =
  'Given a issueTemplateName, this function creates a new custom process and a tab template.';

// The input model
export interface InputInterface {
  issueTemplateName?: string;
}

// The sample input, prefilled in the editor
const sample: InputInterface = {
  issueTemplateName: '<PREFILLED USER ID>'
};

// The actual function called with the input
/**
 *  async (props: InputInterface)
 * can also be written as
 *  async ({TEMPLATE_PROP, userId, documentId}: InputInterface)
 * @param param0
 * @returns
 */
const fn =
  ({ tenantId }) =>
  async (props: InputInterface) => {
    console.log(props.issueTemplateName);
    const tenantFetch = iBinderFetch({ tenantId });

    await ImpersonateTenant({ tenantId });

    const IssueTemplate = await tenantFetch(`${IssuesApi}/templates`, {
      method: 'POST',
      body: JSON.stringify(getStandardIssueTemplate(props.issueTemplateName))
    });
    const IssueTemplate_response = await IssueTemplate.json();

    const workFlowTemplate = await tenantFetch(
      `${IssuesApi}/workflowTemplate`,
      {
        method: 'POST',
        body: JSON.stringify(
          getStandardWorkflowTemplate(
            IssueTemplate_response.id,
            props.issueTemplateName
          )
        )
      }
    );

    const workFlowTemplate_response = await workFlowTemplate.json();

    const NewTabTemplate = await tenantFetch(`${BindersApi}/templates/tabs`, {
      method: 'POST',
      body: JSON.stringify(
        getStandardTabTemplate(
          props.issueTemplateName,
          workFlowTemplate_response.id
        )
      )
    });

    const NewTabTemplate_response = await NewTabTemplate.json();

    const EditedTabTemplate = await tenantFetch(
      `${BindersApi}/templates/tabs/${NewTabTemplate_response.id}`,
      {
        method: 'PUT',
        body: JSON.stringify(
          getStandardTabTemplate(
            props.issueTemplateName,
            workFlowTemplate_response.id,
            NewTabTemplate_response.id
          )
        )
      }
    );

    const EditedTabTemplate_response = await EditedTabTemplate.json();

    console.log('THE ISSUETEMPLATE', IssueTemplate);

    return JSON.stringify({
      IssueTemplate: IssueTemplate_response,
      workFlowTemplate: workFlowTemplate_response,
      OriginalTabTemplate: NewTabTemplate_response,
      tabtemplate: EditedTabTemplate_response
    });
  };

// *****************************************************************************
// END - The part between START and END is the part that is added to the file.
// *****************************************************************************

export default {
  onSubmit:
    ({ tenantId }) =>
    async (jsonData) =>
      await fn({ tenantId })(jsonData),
  sample,
  id,
  name,
  description,
  githubUrl
};
